module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Expand-arrows-e122c2a7a80dca4c247013417e42d9bf.svg";